export const API_BASE_URL = window._env_.API_URL;
// export const API_BASE_URL = process.env.API_URL;
